import React, { useEffect, useState } from "react"
import { NavLink } from "react-router-dom"
import Loader from "../subsidiary/Loader/Loader"
import {useDispatch, useSelector} from "react-redux";
import {fetchPayments} from "./paymentsSlice";
import ProposalItem from "../Proposal/components/ProposalItem";

const Payments = () => {
    const dispatch = useDispatch()
    const proposal = useSelector(state => state.paymentsSlice.payments)


    const [isLoaded, setIsLoaded] = useState(false)
    useEffect(() => {
        dispatch(fetchPayments())
        setTimeout(() => {
            setIsLoaded(true)
        }, 1500);
    }, [dispatch])

    return (
        <>
            {isLoaded ?
                <>
                    <section className="main">
                        <div className="content-wrapper">
                            <div className="page-title-container">
                                <h1 className="page-title ">
                                    Выплаты
                                </h1>
                            </div>
                            <div style={{marginBottom: '50px'}}>В этом разделе будет отображена информация по срокам
                                выплат на основании поступивших от Вас заявлений на материальную помощь или компенсации
                                стоимости путевок / спортивных абонементов.
                            </div>
                            <div>
                                {proposal.length > 0 ? proposal.map((proposal, i) => {
                                    return <NavLink key={i.toString()} to={`/payments/${proposal.id}`}><ProposalItem
                                        proposal={proposal}/></NavLink>
                                }) : <div>Выплат пока нет</div>}
                            </div>
                        </div>
                    </section>
                </>
                : <Loader/>}
        </>
    )
}
export default Payments